import React from 'react';

import Input from 'components/shared/Input/Input';
import Allowed from 'components/shared/Permissions/Allowed';
import CurrencyInput from 'components/shared/CurrencyInput/CurrencyInput';

import Wrapper from '../Wrapper/Wrapper';

const PricingSection = ({ formik }) => {
  return (
    <Wrapper isColumn>
      <Allowed requiredPermissions="payments.read" requiredModules="medipay.payment_suite">
        {/* Row 1: Self Pay, State Tax, Local Tax */}
        <div className="grid grid-cols-2 items-end gap-4">
          <CurrencyInput
            label="Self pay price"
            name="selfPay"
            parentClassName="flex w-full flex-col"
            id="selfPayInput"
            data-qa="selfPay-input"
            value={formik.values.total_cost_cents}
            onValueChange={(value) => formik.setFieldValue('total_cost_cents', value)}
            error={formik.errors.total_cost_cents}
          />
          <Allowed requiredModules="medipay.tax">
            <div className="grid grid-cols-2 gap-4">
              <Input
                actionButtonText="%"
                placeholder="0"
                label="State tax"
                id="productStateTax"
                className="flex-1"
                error={formik?.errors.state_tax_rate}
                value={formik?.values?.state_tax_rate}
                onChange={(event) => formik?.setFieldValue('state_tax_rate', +event.target.value)}
              />
              <Input
                actionButtonText="%"
                label="Local tax"
                placeholder="0"
                id="productLocalTax"
                className="flex-1"
                error={formik?.errors.local_tax_rate}
                value={formik?.values?.local_tax_rate}
                onChange={(event) => {
                  formik?.setFieldValue('local_tax_rate', +event.target.value);
                }}
              />
            </div>
          </Allowed>
        </div>

        {/* Row 2: Standard charge and Medicare Allowable */}
        <div className="flex items-end gap-4">
          <CurrencyInput
            label="Standard charge"
            name="standardCharge"
            parentClassName="flex flex-1 flex-col"
            id="standardChargeInput"
            data-qa="standardCharge-input"
            value={formik.values.standard_charge}
            onValueChange={(value) => formik.setFieldValue('standard_charge', value)}
            error={formik.errors.standard_charge}
          />
          <CurrencyInput
            label="Medicare allowable"
            name="medicareAllowable"
            parentClassName="flex flex-1 flex-col"
            id="medicareAllowableInput"
            data-qa="medicareAllowable-input"
            value={formik.values.par_amount}
            onChange={formik.handleChange}
            disabled
          />
        </div>
      </Allowed>
    </Wrapper>
  );
};

export default PricingSection;
